<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <main-filter
      :providers="user_types"
      providers_title="الأقسام"
      :orderStatuses="orderStatusItems"
      :defaultStatus="$route.query.status || ''"
      :withSearch="false"
      :date-start="true"
      :date-end="true"
      @getResult="setRows"
    />
    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <!-- <div class="row mb-5">
          <div class="wrraper">
            <stats-card
              :title="$t('transactionNum')"
              :number="statisticsItem.number"
            ></stats-card>
          </div>
        </div> -->
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <main>
          <v-data-table
            class="thumb strip"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
            show-select
            v-model="selected"
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <!-- Start:: Users Routes -->
            <template v-slot:[`item.user`]="{ item }">
              <router-link
                v-if="item.user"
                class="ling_to_user"
                :to="
                  {
                    client: '/client/show/',
                    store: '/store/show/',
                    restaurant: '/restraunts/show/',
                    car_company: '/rentals/show/',
                    driver: '/driver/show/',
                  }[item.user.user_type] + item.user.id
                "
              >
                <img class="image" :src="item.user.avatar" />
                <!-- @error="replaceImage" -->
                <span>
                  {{ item.user.full_name }}
                </span>
              </router-link>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <template v-slot:[`item.phone`]="{ item }">
              <div v-if="item.withdraw_type == 'stc'">
                {{ item.phone_number }}
              </div>
              <!-- <div v-else-if="item.withdraw_type != 'stc'">
                {{ item.user.phone_code + "" + item.user.phone }}
              </div> -->
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <template v-slot:[`item.phone_number`]="{ item }">
              <div v-if="item.phone_number">
                {{ item.phone_number }}
              </div>
              <!-- <div v-else-if="item.withdraw_type != 'stc'">
                {{ item.user.phone_code + "" + item.user.phone }}
              </div> -->
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>

            <template v-slot:[`item.iban`]="{ item }">
              <span class="ling_to_user" v-if="item.iban">
                {{ item.iban }}
              </span>
              <span class="ling_to_user" v-else>لا يوجد</span>
            </template>
            <!-- <template v-slot:[`item.status`]="{ item }">
              <span v-if="item.status == 'pending'" class="status pending">
                {{ item.status }}
              </span>

              <span v-if="item.status == 'accepted'" class="status success">
                {{ item.status }}
              </span>
              <span v-if="item.status == 'rejected'" class="status canceled">
                {{ item.status }}
              </span>
            </template> -->
            <template v-slot:[`item.status`]="{ item }">
              <div class="action">
                <div
                  v-if="
                    item.status == 'completed' ||
                    item.status == 'rejected' ||
                    item.status == 'processing'
                  "
                >
                  <span
                    v-if="item.status == 'rejected'"
                    class="status canceled"
                  >
                    مرفوض
                  </span>
                  <span
                    v-if="item.status == 'processing'"
                    class="status pending"
                  >
                    قيد المعالجة
                  </span>
                  <span
                    v-if="item.status == 'completed'"
                    class="status success"
                  >
                    مكتملة
                  </span>
                </div>
                <div
                  class="select-wrapper selecet_shadow mx-auto"
                  style="width: 200px"
                  v-else
                >
                  <div class="input_wrapper">
                    <v-select
                      label="قيد الانتظار"
                      solo
                      :items="orderStatusList(item.status)"
                      @input="changeStatus($event, item.id)"
                    ></v-select>
                  </div>
                </div>
              </div>
            </template>
            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon> -->
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <div class="d-flex justify-content-between">
                <h3 class="title table-title">طلبات السحب</h3>
                <div
                  class="p-2 frm-action d-flex flex-row gap-2"
                  v-if="selected.length"
                >
                  <button class="export btn button_style_1">
                    <export-excel
                      :fetch="exportFields"
                      :meta="json_meta"
                      name="طلبات السحب"
                      worksheet="طلبات السحب"
                    >
                      Export <i class="fal fa-download"></i
                    ></export-excel>
                  </button>
                  <v-select
                    class="change_status_select"
                    label="تغير الحالة"
                    :items="orderStatusList('pending')"
                    @input="changeMultiStatus($event)"
                  ></v-select>
                </div>
              </div>

              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Start:: Text Content Modal -->
              <TextContentModal
                @toggleModal="controlReportReasonModalModal"
                :modalIsActive="reportReasonModalIsOpen"
                :title="$t('reportReason')"
                :textContent="reportReasonToShow"
              />
              <!-- End:: Text Content Modal -->

              <!-- Start:: Process Type Modal -->
              <ProcessTypeModal
                @toggleModal="processModalIsOpen = !processModalIsOpen"
                :modalIsActive="processModalIsOpen"
                :btnIsLoading="btnIsLoading"
                @confirm="handleProcessTypeConfirm"
              />
              <!-- End:: Process Type Modal -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container text-center mb-5 d-flex justify-content-end"
          >
            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";
import ProcessTypeModal from "@/components/Modals/ProcessTypeModal.vue";
// End:: Importing Modals

export default {
  name: "UsersReports",

  components: {
    TextContentModal,
    ProcessTypeModal,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.transaction.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loading
      loading: false,
      selected: [],
      processModalIsOpen: false,
      statusToChange: null,
      idToChange: null,
      isMultiChange: false,
      btnIsLoading: false,
      filter_data: null,
      user_types: [
        {
          text: "العملاء",
          value: "client",
        },
        {
          text: "المناديب",
          value: "driver",
        },
        {
          text: "المتاجر",
          value: "restaurant",
        },
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "العميل",
            align: "center",
            value: "user",
            sortable: false,
          },
          {
            text: "رقم هاتف العميل",
            align: "center",
            value: "user.phone",
            sortable: false,
          },
          {
            text: "رقم السحب",
            align: "center",
            value: "phone_number",
            sortable: false,
          },
          {
            text: "رقم الحساب",
            align: "center",
            value: "account_number",
            sortable: false,
          },
          {
            text: "اسم البنك",
            align: "center",
            value: "bank_name",
            sortable: false,
          },
          // {
          //   text: "رقم الايبان",
          //   align: "center",
          //   value: "iban",
          //   sortable: false,
          // },
          {
            text: "مبلغ السحب",
            align: "center",
            value: "amount",
            sortable: false,
          },
          {
            text: "المبلغ قبل",
            align: "center",
            value: "balance",
            sortable: false,
          },
          {
            text: "المبلغ بعد",
            align: "center",
            value: "balance_after_withdraw",
            sortable: false,
          },
          {
            text: "رقم الايبان",
            align: "center",
            value: "iban",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "center",
            value: "status",
            sortable: false,
          },
          {
            text: "الموظف",
            align: "center",
            value: "accepted_by_user",
            sortable: false,
          },
          {
            text: "التاريخ",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          // {
          //   text: "التحكم",
          //   value: "actions",
          //   sortable: false,
          //   align: "center",
          // },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    orderStatusItems() {
      if (this.lang == "ar") {
        return [
          {
            text: "قيد الانتظار",
            value: "pending",
          },
          {
            text: "قيد المعالجة",
            value: "processing",
          },
          {
            text: "مكتملة",
            value: "completed",
          },
          {
            text: "مرفوض",
            value: "rejected",
          },
        ];
      } else {
        return [
          {
            text: "Pending",
            value: "pending",
          },
          {
            text: "Processing",
            value: "processing",
          },
          {
            text: "Completed",
            value: "completed",
          },
          {
            text: "Rejected",
            value: "rejected",
          },
        ];
      }
    },
  },

  methods: {
    exportFields() {
      let newData = [];
      this.selected.forEach((el) => {
        let newObject = {};
        newObject[`العميل`] = el.user.full_name;
        newObject[`الهاتف`] = el.user.phone;
        newObject[`رقم الحساب`] = el.account_number;
        newObject[`اسم البنك`] = el.bank_name;
        newObject[`مبلغ السحب`] = el.amount;
        newObject[`المبلغ قبل`] = el.balance;
        newObject[`المبلغ بعد`] = el.balance_after_withdraw;
        newObject[`الحالة`] =
          el.status == "pending" || !el.status
            ? "قيد الانتظار"
            : el.status == "completed"
            ? "مكتملة"
            : el.status == "rejected"
            ? "مرفوض"
            : "";
        newObject[`الموظف`] = el.accepted_by_user;
        newObject[`التاريخ`] = el.created_at;

        // newObject[`${this.$t("forms.labels.city")}`] = el.city;
        newData.push(newObject);
      });
      return newData;
    },
    changeStatus(currStatus, id) {
      if (currStatus === "completed") {
        this.statusToChange = currStatus;
        this.idToChange = id;
        this.isMultiChange = false;
        this.processModalIsOpen = true;
      } else {
        this.submitChangeStatus(currStatus, id);
      }
    },
    changeMultiStatus(currStatus) {
      if (currStatus === "completed") {
        this.statusToChange = currStatus;
        this.isMultiChange = true;
        this.processModalIsOpen = true;
      } else {
        this.submitChangeMultiStatus(currStatus);
      }
    },
    submitChangeStatus(currStatus, id, processType = null) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      submit_data.append("status", currStatus);
      if (processType) {
        submit_data.append("process_type", processType);
      }
      this.$axios({
        method: "POST",
        url: `cashout-requests/${id}/accept`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          this.processModalIsOpen = false;
          this.setRows();
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.status == "fail"
          ) {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }
          this.setRows();
          this.btnIsLoading = false;
          this.processModalIsOpen = false;
        });
    },
    submitChangeMultiStatus(currStatus, processType = null) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      submit_data.append("status", currStatus);
      if (processType) {
        submit_data.append("process_type", processType);
      }

      if (this.selected.length) {
        this.selected.forEach((el, index) => {
          submit_data.append(`cash_requests[${index}]`, el.id);
        });
      }
      this.$axios({
        method: "POST",
        url: `cashout-requests/accepts`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          this.processModalIsOpen = false;
          this.selected = [];
          this.setRows();
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.status == "fail"
          ) {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }
          this.setRows();
          this.btnIsLoading = false;
          this.processModalIsOpen = false;
        });
    },
    handleProcessTypeConfirm(processType) {
      if (this.isMultiChange) {
        this.submitChangeMultiStatus(this.statusToChange, processType);
      } else {
        this.submitChangeStatus(
          this.statusToChange,
          this.idToChange,
          processType
        );
      }
    },
    orderStatusList(status) {
      if (status == "pending") {
        return [
          {
            text: "قبول",
            value: "completed",
          },
          { text: "رفض", value: "rejected" },
        ];
      }
    },
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/transactions/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/transactions/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/transactions/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `user_reports/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows(e) {
      if (e) {
        this.filter_data = e;
      }

      const queryStatus = this.$route.query.status || "";
      const selectedStatus =
        e !== undefined
          ? e?.status
            ? e.status.value || e.status
            : ""
          : this.filter_data?.status
          ? this.filter_data.status.value || this.filter_data.status
          : queryStatus;

      // Push status to query if selected from filter and different from current query
      if (e !== undefined && selectedStatus !== queryStatus) {
        const query = { ...this.$route.query };
        if (selectedStatus) {
          query.status = selectedStatus;
        } else {
          delete query.status;
        }
        if (query.page) {
          delete query.page;
          this.paginations.current_page = 1;
        }
        this.$router.push({ query }).catch(() => {});
        return;
      }

      const activeStatus = selectedStatus || queryStatus;

      this.loading = true;
      this.$axios({
        method: "GET",
        url: "cashout_requests",
        params: {
          page: this.paginations.current_page,
          status: activeStatus,
          user_type: this.filter_data?.provider
            ? this.filter_data.provider.value || this.filter_data.provider
            : "",
          created_from: this.filter_data?.dateStart || "",
          created_to: this.filter_data?.dateEnd || "",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.push({ query: { ...this.$route.query, page: e } }).catch(() => {});
      this.setRows();
    },
  },

  watch: {
    "$route.query.status"(newStatus) {
      if (this.filter_data) {
        if (newStatus) {
          const found = this.orderStatusItems.find((s) => s.value === newStatus);
          this.filter_data.status = found || newStatus;
        } else {
          this.filter_data.status = "";
        }
      }
      this.setRows();
    },
    "$route.query.page"(newPage) {
      if (newPage) {
        this.paginations.current_page = +newPage;
      }
    },
  },

  // ======= hooks
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.ling_to_user {
  &:hover {
    color: green;
  }
}
.change_status_select {
  border: 1px solid rgba(128, 128, 128, 0.444);
  padding: 0px 10px !important;
}
</style>
